export default __webpack_public_path__ + "static/media/loading.548e3f12.gif";